import { format } from 'date-fns'

import { useDateStore } from '@/components/DateInput'
import { VehicleAllocationList } from './VehicleAllocationList'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'

import styles from './VehicleAllocation.module.scss'

export const ReaderVehicleAllocation = () => {
    const { source } = useReaderLogStore()
    const { date } = useDateStore()

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>{source?.title} vehicle allocation</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>
            <div className={styles.container}>
                <VehicleAllocationList />
            </div>
        </section>
    )
}
